<template>
    <div class="table-responsive">
        <table class="table-bar">
            <tbody>
                <tr>
                    <td :class="row?'progress__bar':''" v-for="(row, index) in rows" :key="index"></td>
                </tr>
            </tbody>
            <tfoot>
                <tr class="progress">
                    <td class="right-line" v-for="column in columns" :key="column"><strong>{{ column }}</strong></td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
export default {
    props : {
        columns : {
            type : Array,
            required : false,
            default : function () {
                return [
                    'Gate IN',
                    'Inspeccionado',
                    this.$t('message.estimado'),
                    this.$t('message.aprobado'),
                    this.$t('message.reparado'),
                    this.$t('message.dispatched')
                    
                ];
            }
        },
        rows : {
            type : Array,
            required : false,
            default : function () {
                return [
                    false,
                    false,
                    false,
                    false,
                    false
                ];
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "~@/abstracts/_variables.scss";

.progress__bar {
    height: 100%;
    overflow: hidden;
    background-color: $brand-success;
    background-image: linear-gradient(
      45deg,
      rgba(255,255,255,.15) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255,255,255,.15) 50%,
      rgba(255,255,255,.15) 75%,
      transparent 75%,
      transparent
    );
    background-size: 1rem 1rem;
    animation: progress-bar-move 1s linear infinite;

  }
@keyframes progress-bar-move {
  0% {
    background-position: 1rem 0;
  }
  100% {
    background-position: 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/element/TableBar.vue